module.exports = __webpack_public_path__ + "img/h5Pay (1).103da5f3.png";